import {DocumentSearchService} from '|shared';
import {SearchRecordSourceDocumentFileDto} from '|api/elastic';
import {of} from 'rxjs';
import {IczTableDataSource} from '@icz/angular-table';

export class ObjectsForStorageUnitInsertDatasource extends IczTableDataSource<SearchRecordSourceDocumentFileDto> {
  constructor(searchService: DocumentSearchService, storageUnitId: Nullable<number>) {
    super(
      searchParams => {
        if (storageUnitId) {
          return searchService.findAllEntitiesForStorageUnitInsert(searchParams, storageUnitId);
        }
        else {
          return of({
            content: [],
            numberOfElements: 0,
            last: false,
            first: false,
            totalElements: 0
          });
        }
      },
    );
  }
}
